import { NavLink, useHistory } from "react-router-dom";
import { ResponsivePresetKeys, ResponsivePresets } from "../../../../modules/configs/responsiveImageConfigs";
import { FocusableComponentLayout, FocusDetails, useFocusable } from "../../../../modules/spatialNavigation";
import ImageGenerator from "../../../shared/imageGenerator/ImageGenerator";
import * as styles from "./styles.module.scss";

interface IProps {
  link: string;
  focusKey: string;
  landscapeImagePath: string;
  onFocus: (layout: FocusableComponentLayout, props: object, details: FocusDetails) => void;
}

const CardItem = (props: IProps) => {
  const history = useHistory();

  const { ref, focused } = useFocusable({
    focusKey: props.focusKey,
    onFocus: props.onFocus,

    onEnterPress: (e) => {
      history.push(props.link);
    },
  });

  return (
    <NavLink ref={ref} className={`${styles.categoryCard} ${focused ? styles.focused : ""}`} to={props.link}>
      <ImageGenerator
        lazyLoad
        noBlurPlaceholder={true}
        imageType="landscape"
        sizes={ResponsivePresets[ResponsivePresetKeys.EXPANDABLE_CARD_CAROUSEL]}
        src={props.landscapeImagePath}
      />
    </NavLink>
  );
};
export default CardItem;
